var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5825 13.6893H10.4125L15.2925 8.80929C15.6825 8.41929 15.6825 7.77929 15.2925 7.38929C15.1057 7.20203 14.852 7.0968 14.5875 7.0968C14.323 7.0968 14.0693 7.20203 13.8825 7.38929L7.2925 13.9793C6.9025 14.3693 6.9025 14.9993 7.2925 15.3893L13.8825 21.9793C14.2725 22.3693 14.9025 22.3693 15.2925 21.9793C15.6825 21.5893 15.6825 20.9593 15.2925 20.5693L10.4125 15.6893H21.5825C22.1325 15.6893 22.5825 15.2393 22.5825 14.6893C22.5825 14.1393 22.1325 13.6893 21.5825 13.6893Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow_right_white.cd3af80a367f522b1ab9ac8f55649ba3.svg";
export { ForwardRef as ReactComponent };